export default [
  {
    path: '/vistoria/:vistoriaId/imovel-ambiente',
    name: 'AmbienteList',
    component: () => import('./ImovelAmbienteList'),
    meta: {
      routerGo: 'vistoria/:vistoriaId/ambiente-new',
      routerEdit: '/ambiente-edit',
      domain: 'Vistoria',
      sidebar: false,
      icon: 'visibility',
      title: 'Ambientes',
    },
    children: [
      {
        path: '/ambiente/:id',
        name: 'ItensAmbienteImovel',
        component: () => import('./Itens/ImovelItensList'),
        meta: {
          routerGo: '/ambiente/:id/itens-new',
          routerEdit: '/ambiente/:id/itens-edit',
          routerBack: '/ambiente',
          domain: 'ItensAmbienteImovel',
          sidebar: false,
          icon: 'keyboard_backspace',
          title: 'ItensAmbienteImovel',
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/Imovel/Vistoria/Ambiente/ImovelAmbienteRouter.js